import { render, staticRenderFns } from "./StringFormatter.Default.vue?vue&type=template&id=4f2553fd"
import script from "./StringFormatter.Default.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports